export const SupportButtonLabels: { [name: string]: SupportButtonLabel } = {
  en: {
    header: 'Need help?',
    content: 'Didn’t find what you are looking for?\nWe\'re here to help!',
    footer: 'Contact support'
  },
  fr: {
    header: 'Besoin d’aide?',
    content: 'Vous ne trouvez pas ce que vous cherchez?\nNous sommes là pour vous aider',
    footer: 'Contactez le support'
  },
  de: {
    header: 'Brauchen Sie Hilfe?',
    content: 'Haben Sie nicht gefunden, was Sie suchen?\nWir helfen Ihnen gerne!',
    footer: 'Support kontaktieren'
  },
  sv: {
    header: 'Behöver du hjälp?',
    content: 'Hittade du inte det du sökte?\nVi finns här för att hjälpa dig.',
    footer: 'Kontakta supporten'
  },
  ru: {
    header: 'Нужна помощь?',
    content: 'Не нашли то, что искали?\nМы здесь, чтобы вам помочь!',
    footer: 'Связаться с поддержкой'
  },
  nl: {
    header: 'Hulp nodig?',
    content: 'Kunt u niet vinden wat u zoekt?\nWij zijn er om u te helpen!',
    footer: 'Contact Support'
  },
  it: {
    header: 'Serve aiuto?',
    content: 'Non hai trovato ciò che cercavi?\nSiamo qui per aiutarti!',
    footer: 'Contatta il supporto'
  },
  es: {
    header: '¿Necesitas ayuda?',
    content: '¿No encontraste lo que buscas?\n¡Estamos aquí para ayudar!',
    footer: 'Soporte'
  },
  pl: {
    header: 'Potrzebujesz pomocy?',
    content: 'Nie znalazłeś czego szukasz?\nPomożemy!',
    footer: 'Skontaktuj się z obsługą klienta'
  },
  ja: {
    header: 'お問い合わせ',
    content: 'お探しの情報が見つからない場合は、\nお気軽にお問い合わせください。',
    footer: 'カスタマーサポート'
  },
  zh: {
    header: '需要帮助吗？',
    content: '没有找到您想要的内容？\n欢迎联系我们！',
    footer: '联系我们'
  },
  fi: {
    header: 'Tarvitsetko apua?',
    content: 'Etkö löytänyt etsimääsi? Me autamme sinua!',
    footer: 'Ota yhteyttä tukeen'
  }
};

export interface SupportButtonLabel {
  header: string,
  content: string,
  footer: string
}
